import React, { useState, useEffect } from 'react';
import '../InPrincipalEditor.css';
import delete_icon from '../../../../images/icons/AuditTrailIcons/delete_icon_black.svg';
import CommonBtn from '../../../../containers/LeadProfile/CommonBtn/CommonBtn';

function TermsRow({
  isCreateMode,
  onClickAction,
  data,
  setTermsData,
  onDelete,
  addNewTerms,
  index
}) {
  const [showEditMode, setShowEditMode] = useState(false);
  const [showEditDetele, setShowEditDelete] = useState(false);
  const [text, setText] = useState(data?.text || '');

  return (
    <div className='mb-6'>
      {!showEditMode && !isCreateMode && (
        <div className="canEditMode" onClick={() => setShowEditDelete(false)}>
          <div className="flex">
            <div className="flex border border-grey-350  rounded lg:w-6/12  w-full" style ={{minHeight:'47px'}}>
              <div className="text-grey-600 py-1 px-1  break-words w-11/12">
                <p className="pr-6 pt-2 text-sm font-roboto font-light">
                  {text}
                </p>
              </div>
              <div className="relative">
                <div
                  className="text-grey-600 text-2xl font-medium relative h-0 cursor-pointer w-1/12"
                  onClick={e => {
                    e.stopPropagation();
                    setShowEditDelete(!showEditDetele);
                  }}
                >
                  ...
                </div>
                {showEditDetele && (
                  <div className="flex flex-col shadow rounded  text-black text-xs mt-1 more_option">
                    <div className="cursor-pointer hover:font-medium">
                      <img
                        src={delete_icon}
                        alt=""
                        className="inline-block pr-3"
                      />
                      <span
                        onClick={() => {
                          onDelete(index);
                        }}
                      >
                        Delete
                      </span>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      )}
      {(showEditMode || isCreateMode) && (
        <div className="topTextArea ">
          <p className="text-grey-600 pb-2">Add Terms and Conditions</p>
          <div className="lg:flex md:flex h-22">
            <div className="items-baseline border border-grey-350 rounded lg:w-6/12  w-full ">
              <textarea
                className="w-full py-2 px-3 rounded-md text-black"
                value={text}
                onChange={e => {
                  setText(e.target.value);
                }}
                rows={3}
              />
            </div>
            <div className="lg:mt-12 md:mt-12 mt-2 lg:ml-4 md:ml-4 float-right ">
              <CommonBtn
                value={isCreateMode ? 'Add' : 'Submit'}
                onClick={() => {
                  setShowEditMode(false);
                  if (isCreateMode) {
                    if (text) {
                      addNewTerms(text);
                    }
                    setText('');
                  }
                  if (onClickAction) {
                    onClickAction({
                      info: {
                        text,
                        data
                      }
                    });
                  }
                }}
                classNameStyle="hover:font-medium"
                stylesBtn={{
                  backgroundColor: '#1CB1BD',
                  border: 'none',
                  color: 'white',
                  padding: '5px 15px'
                }}
              />
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default TermsRow;